import { CarWithDealer } from "../data/models";

// Helper for turning filters into query string
export const filtersToQueryString = (filters: Record<string, string[]>) => {
  const queryParts = Object.entries(filters)
    .filter(([_, values]) => values.length > 0)
    .map(
      ([key, values]) => `${key}=${values.map(encodeURIComponent).join(",")}`
    );
  return queryParts.join("&");
};

export const filtersToQueryObject = (filters: Record<string, string[]>) => {
  const query: Record<string, string> = {};

  Object.entries(filters)
    .filter(([_, values]) => values.length > 0)
    .forEach(([key, values]) => {
      // Kodiramo samo vrijednosti
      query[key] = values.map((value) => value).join(",");
    });

  return query;
};

// Helper for turning query string into filters
export const queryStringToFilters = (query: URLSearchParams) => {
  const filters: Record<string, string[]> = {};
  query.forEach((value, key) => {
    filters[key] = value.split(",");
  });
  return filters;
};

// Helpers for sorting carousel vehicles
function normalizeColor(color: string | null | undefined): string {
  return typeof color === "string" ? color.toLowerCase() : "unknownColor"; // if color input is invalid
}

function distributeColors(vehicles: CarWithDealer[]): CarWithDealer[] {
  const colorGroups: Record<string, CarWithDealer[]> = {};
  vehicles.forEach((v) => {
    const normColor = normalizeColor(v.color_f);
    if (!colorGroups[normColor]) colorGroups[normColor] = [];
    colorGroups[normColor].push(v);
  });

  const sortedColors = Object.keys(colorGroups).sort(
    (a, b) => colorGroups[b].length - colorGroups[a].length
  );
  const result: CarWithDealer[] = [];

  while (result.length < vehicles.length) {
    for (const color of sortedColors) {
      if (colorGroups[color].length > 0) {
        result.push(colorGroups[color].shift()!);
      }
    }
  }
  return result;
}

export function sortAndGroupVehicles(
  vehicles: CarWithDealer[]
): CarWithDealer[][] {
  const grouped: Record<number, CarWithDealer[]> = {};
  vehicles.forEach((v) => {
    const key = isNaN(parseInt(v.equipment_sort, 10))
      ? 999 // If equipment_sort is invalid, it goes to the end of the list
      : parseInt(v.equipment_sort, 10);
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(v);
  });

  const sortedKeys = Object.keys(grouped)
    .map(Number)
    .sort((a, b) => a - b);
  return sortedKeys.map((key) => distributeColors(grouped[key]));
}

export const getUTMTrackingData = () => {
  const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

  const tracking: Record<string, string> = {};

  utmKeys.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value) {
      tracking[key] = value;
    }
  });

  return { tracking };
};


export const safeHref = (raw?: string) => {
  if (!raw) return undefined;
  try {
    const u = new URL(raw, window.location.origin);
    return u.protocol === "http:" || u.protocol === "https:" ? u.toString() : undefined;
  } catch {
    return undefined;
  }
};


export const sortModels = (models: string[] = []): string[] => {
  const predefinedOrder = [
    "c3",
    "c3 aircross",
    "c4",
    "c5 aircross",
    "berlingo furgon",
    "berlingo business",
    "jumper",
    "jumpy furgon",
  ];

  return models.sort((a, b) => {
    const nameA = a.toLowerCase();
    const nameB = b.toLowerCase();

    const indexA = predefinedOrder.indexOf(nameA);
    const indexB = predefinedOrder.indexOf(nameB);

    const inListA = indexA !== -1;
    const inListB = indexB !== -1;

    if (inListA && inListB) {
      return indexA - indexB;
    } else if (inListA) {
      return -1;
    } else if (inListB) {
      return 1;
    } else {
      return nameA.localeCompare(nameB);
    }
  });
};
